export default __webpack_public_path__ + "static/media/hiei_back.717eef05.bmp";